import { SENDER_TYPE } from 'components/MessageBuilder/components';
import { EmailSendOptionsTeamMember } from './email-send-options/types';
import { TFunction } from 'react-i18next';
import { AutomationVariableDataType } from 'pages/AutomationEngine/types';

interface ValidateProps {
  email: any;
  teamMember: EmailSendOptionsTeamMember;
  type: string;
  externalAccount: any;
  senderType: string;
}

export const validIntegratedInbox = (email: ValidateProps) => {
  return email && email?.senderType === SENDER_TYPE.SPECIFIC_INTEGRATED_INBOX
    ? email?.externalAccount
    : true;
};
export const getTranslatedTypes = (
  t: TFunction
): Record<AutomationVariableDataType, string> => {
  const trans: Record<AutomationVariableDataType, string> = {
    boolean: t('Boolean'),
    employee: t('Employee'),
    entity: t('Entity'),
    date: t('Date'),
    datetime: t('DateTime'),
    number: t('Number'),
    phone_number: t('Phone Number'),
    string: t('String'),
    uuid: t('UUID'),
  };

  return trans;
};
